export enum EField {
  Subject = "subject",
  Description = "notes",
  Location = "location",
  Attachments = "attachments",
}
